import React from 'react';
import { TYPE_META, TYPE_ORDER } from './appTypes';
import './TypeLegend.css';

/**
 * Key for the colored type dots the cards carry, sitting under the page title.
 *
 * Only Home decorates its cards with `typeKeys`, so `StorePage` renders this
 * only for a list that can show dots at all — on the per-type pages every card
 * is the same type and there is nothing to explain.
 *
 * Divs with explicit list roles rather than `ul`/`li`: Home also imports
 * `Drivers.css` for the admin pages, whose bare `li` rule would centre and flex
 * these entries. The roles keep the list semantics that markup would have given.
 */
export default function TypeLegend() {
  return (
    <div className="itcLegend" role="list" aria-label="App type key">
      {TYPE_ORDER.map((type) => (
        <span key={type} className="itcLegendItem" role="listitem">
          <span className="itcLegendDot" data-type={type} aria-hidden="true" />
          {TYPE_META[type].label}
        </span>
      ))}
    </div>
  );
}
